module.exports = __webpack_public_path__ + "img/CY120020.ecf0b3bd.png";